// extracted by mini-css-extract-plugin
export default {"block":"ui_block__vDzci","iconWrapper":"ui_iconWrapper__+F9y7","text":"ui_text__wb5w1","modalWrapperLoader":"ui_modalWrapperLoader__zTm03","mobileModal":"ui_mobileModal__MITU2"};